module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/sizing/step2-7be454c849a10d1b6cc13cf9b3970fe8.jpg";